import { AxiosInstance } from 'axios';

export default class UserController {
  protected readonly client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }
}
